import { CrudBuilderConfig } from '../../components/crudbuilder/models/crud-builder-config';
import ListFormatter from '../../helpers/list-formatter';
import Formatter from '../../helpers/formatter';
import { FieldConfig } from '../../components/crudbuilder/models/field-config';
import { Person } from '../../state/people';
import { createRentalHome, RentalHome } from '../../state/rental-homes';

export class RentalHomesCrudBuilderConfigClass extends CrudBuilderConfig {
  singular   = 'Rental Home';
  plural     = 'Rental Homes';
  modelAlias = 'rental-home';
  path       = 'rental-homes';
  fields     = [
    new FieldConfig('person_id', 'person', 'Person'),
    new FieldConfig('cancellation_period_configuration_id', 'cancellation_period', 'Cancellation Period'),
    new FieldConfig('owner', 'text', 'Owner'),
    new FieldConfig('rent', 'money'),
    new FieldConfig('start_date', 'date'),
    new FieldConfig('end_date', 'date'),
  ];
  readFields = [
    new FieldConfig('cancellation_period', 'relation_config'),
    new FieldConfig('owner', 'string'),
    new FieldConfig('rent', 'string'),
    new FieldConfig('start_date', 'date'),
    new FieldConfig('end_date', 'date'),
  ];

  listView(model: RentalHome) {
    const view = new ListFormatter()
      .fHead('Owner', model.owner)
      .fSub('Rent', Formatter.formatMoney(model.rent))
      .fP(Formatter.formatDate(model.start_date) + ' - ' + Formatter.formatDate(model.end_date))
    ;
    return view.toString();
  }

  getModel() {
    return createRentalHome({});
  }

  getReadTitle(model: RentalHome) {
    return 'Home #' + model.id;
  }

  editPreprocess(model: RentalHome) {
    const nm                                = {...model};
    nm.cancellation_period_configuration_id = nm.cancellation_period.id;
    return nm;
  }

  runBeforeSavingOnAddView(model: RentalHome, states) {
    return model;
  }
}

export const RentalHomesCrudBuilderConfig = new RentalHomesCrudBuilderConfigClass();
